import React from "react";
import * as Moment from "moment";
import { Icon } from "signoxe/components/widgets";
import momentLocalizer from "react-widgets-moment";
import DateTimePicker from "react-widgets/lib/DateTimePicker";
import "./styles.scss";
import loader1 from "../../images/animations/loader1.gif"

momentLocalizer();

const ReportFilter = ({
  downloading,
  title,
  onDownload,
  onClose,
  reportTime,
  reportType,
  onInputChange,
  isCustomDate,
  startTime,
  onStartTimeChange,
  endTime,
  onEndTimeChange,
  onIntervalChange,
  devices,
  reportFormat,
  handleMailReportMessage,
  handleShowMailReportButton,
  showMailReportButton,
  onCustomIntervalChange,
  onMailReport
}) => {
  console.log("StartTime + endTime = ", startTime, endTime);
  return (
    <div className="ReportFilter">
      <div className="ReportFilter__header">
        <div>Select appropriate options: </div>
        <div>
          {" "}
          <Icon
            title="cancel"
            name="times"
            size="1.25rem"
            color="black"
            onClick={() => onClose()}
          />
        </div>
      </div>
      <div className="ReportFilter__content">
        <div className="ReportFilter__contentRow">
          <h4>Report Type</h4>
          <div>
            <div>
              <input
                type="radio"
                value="activeHours"
                name="reportTime"
                onChange={(e) => {
                  onInputChange(e);
                }}
                checked={reportTime === "activeHours"}
              />{" "}
              Active Hours
            </div>
            <div>
              <input
                type="radio"
                value="playbackReport"
                name="reportTime"
                onChange={(e) => onInputChange(e)}
                checked={reportTime === "playbackReport"}
              />{" "}
              Playback Report
            </div>
          </div>

          <div>
            <div>
              <input
                type="radio"
                value="summary"
                name="reportType"
                onChange={(e) => onInputChange(e)}
                checked={reportType === "summary"}
              />{" "}
              Summary
            </div>
            <div>
              <input
                type="radio"
                value="detailed"
                name="reportType"
                onChange={(e) => onInputChange(e)}
                checked={reportType === "detailed"}
              />
              Detailed
            </div>
          </div>
        </div>

        <div className="ReportFilter__content__timeFilter">
          <h4>Period</h4>
          <div>
            <input
              type="radio"
              value={Moment.utc().startOf("day").valueOf()}
              name="reportInterval"
              onChange={(e) =>
                onIntervalChange(e, Moment.utc().endOf("day").valueOf())
              }
            />{" "}
            Today
          </div>
          <div>
            <input
              type="radio"
              value={Moment.utc().subtract(1, "days").startOf("day").valueOf()}
              name="reportInterval"
              onChange={(e) =>
                onIntervalChange(
                  e,
                  Moment.utc().subtract(1, "days").endOf("day").valueOf()
                )
              }
              checked={
                Moment.utc().subtract(1, "days").startOf("day").valueOf() ===
                startTime
              }
            />{" "}
            Yesterday
          </div>
          <div>
            <input
              type="radio"
              name="reportInterval"
              value={Moment.utc().subtract(15, "days").startOf("day").valueOf()}
              onChange={(e) =>
                onCustomIntervalChange(e, Moment.utc().endOf("day").valueOf())
              }
            />{" "}
            Last 15 days
          </div>
          <div>
            <input
              type="radio"
              value="custom"
              name="reportInterval"
              onChange={(e) => onCustomIntervalChange(e)}
            />{" "}
            Custom days
          </div>

          {isCustomDate && (
            <>
              <DateTimePicker
                placeholder="Start date"
                className="expire-on-input"
                culture="en-gb"
                step={15}
                min={new Date(Date.now() - 365 * 24 * 60 * 60 * 1000)}
                timeFormat="HH:mm"
                value={startTime && Moment(startTime).toDate()}
                onChange={(e) => onStartTimeChange(e)}
              />

              <DateTimePicker
                placeholder="End date"
                className="expire-on-input"
                culture="en-gb"
                step={15}
                min={startTime && Moment(startTime).toDate()}
                max={startTime && Moment(startTime).add(15, "days").toDate()}
                timeFormat="HH:mm"
                value={endTime && Moment(endTime).toDate()}
                onChange={(e) => onEndTimeChange(e)}
              />
            </>
          )}
        </div>

        <div className="ReportFilter__contentRow">
          <h3>Format</h3>
          <div>
            <div>
              <input
                type="radio"
                value="pdf"
                name="reportFormat"
                onChange={(e) => onInputChange(e)}
                disabled
                checked={reportFormat === "pdf"}
              />{" "}
              PDF
            </div>
            <div>
              <input
                type="radio"
                value="csv"
                name="reportFormat"
                onChange={(e) => onInputChange(e)}
                checked={reportFormat === "csv"}
              />
              CSV
            </div>
            {showMailReportButton == true ?
            <div>
              <button disabled={downloading} onClick={ (e) => onMailReport()}>Mail Report</button>
            </div>
            :
            <React.Fragment>
            {
              downloading
              ?<div> <img src={loader1} width="24" height="24"/> <button >Downloading...</button></div>
              :<button onClick={(e) => onDownload()}>Download</button>
            }
            </React.Fragment>
          }
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportFilter;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/ReportFilter/index.js